class animateHelper {
	constructor() {
		this.end = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	}

	init() {
	}

	transition(target, animation, phase, endClass) {
		$(target).addClass([animation, endClass]).one(this.end, () => {
			$(target).removeClass(phase == 'in' ? animation : [animation, endClass])
		})
	}

	backgroundAnimate() {
		if ($(window).width() > 768) {
			var lFollowX = 0,
			lFollowY = 0,
			x = 0,
			y = 0,
			friction = 1 / 30;
	
	
			$(window).on('mousemove click', function(e) {
	
				var lMouseX = Math.max(-100, Math.min(100, $(window).width() / 2 - e.clientX));
				var lMouseY = Math.max(-100, Math.min(100, $(window).height() / 2 - e.clientY));
				lFollowX = (5 * lMouseX) / 100; // 100 : 12 = lMouxeX : lFollow
				lFollowY = (5 * lMouseY) / 100;
	
			x += (lFollowX - x) * friction;
			y += (lFollowY - y) * friction;
			
			translate = 'translate(' + x + 'px, ' + y + 'px) scale(1.05)';
	
			$('.background').css({
				'-webit-transform': translate,
				'-moz-transform': translate,
				'transform': translate
			});
	
	
			});
		}
		

	}
}

window.app.add('animate', new animateHelper());